export default __webpack_public_path__ + "static/media/tips-active.64aa4b7b.svg";